<template>
  <va-dropdown
    class="language-dropdown"
    offset="0, 16px"
    fixed
  >
    <va-icon slot="anchor" :name="['flag-icon flag-icon-large', flagIconClass(currentLanguage())]"/>
    <div class="language-dropdown__content pl-4 pr-4 pt-2 pb-2">
      <div class="language-dropdown__item row align--center pt-1 pb-1 mt-2 mb-2"
         v-for="(option, id) in options"
         :key="id"
         :class="{ active: option.code === currentLanguage() }"
         @click="setLanguage(option.code)"
      >
        <va-icon :name="['flag-icon flag-icon-small', flagIconClass(option.code)]"/>
        <span class="dropdown-item__text">
        {{ $t(`language.${option.name}`) }}
      </span>
      </div>
    </div>
  </va-dropdown>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'language-dropdown',
  props: {
    options: {
      type: Array,
      default: () => [
        {
          code: 'gb',
          name: 'english',
        },
        {
          code: 'es',
          name: 'spanish',
        },
        {
          code: 'pt',
          name: 'portuguese',
        },
        {
          code: 'cz',
          name: 'czech',
        },
      ],
    },
  },
  methods: {
    setLanguage (locale) {
      //if(locale === 'cz') locale = 'cs'
      Vue.i18n.set(locale)
      // This will go to the child component (VaDropdown) and will change the data variable
      // isClicked to the contrary value that is set, making it close the panel.
      // this.$children[0].isClicked = !this.$children[0].isClicked

      this.$parent.$parent.$refs.navbar_language_item.$el.click()
    },

    currentLanguage () {
      return Vue.i18n.locale() === 'en' ? 'gb' : Vue.i18n.locale()
    },

    flagIconClass (code) {
      return `flag-icon-${code}`
    },
  },
}
</script>

<style lang="scss">
@import "~flag-icon-css/css/flag-icon.css";

.language-dropdown {
  cursor: pointer;

  .flag-icon {
    background-size: cover;
  }

  &__content {
    background-color: $dropdown-background;
    box-shadow: $gray-box-shadow;
    border-radius: .5rem;
    // width: 12rem;
    .flag-icon-small {
      min-width: 1.5rem;
      min-height: 1.5rem;
      margin-right: .5rem;
    }
  }

  &__item {
    padding-bottom: 0.625rem;
    cursor: pointer;
    flex-wrap: nowrap;
    &:last-of-type {
      padding-bottom: 0 !important;
    }
    &:hover, &.active {
      color: $vue-green;
    }
  }

  .flag-icon:before {
    content: "";
  }

  .flag-icon-large {
    width: 30px !important;
    height: 30px !important;
    display: inline-block;
    background-color: white;
    border-radius: 50%;
    border: 2px solid $lighter-gray;
    overflow: hidden;
    img {
      height: 200%;
      width: 100%;
    }
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
